import { useEffect, useState } from 'react'
import { Icon } from '@iconify/react/dist/iconify.js'
import { contactInfo, socials } from '../../data/info'
import './floatingContact.css'

function FloatingContact() {
    const [isOpen, setIsOpen] = useState(false)

    useEffect(() => {
        document.body.style.overflow = isOpen ? 'hidden' : ''
        return () => { document.body.style.overflow = '' }
    }, [isOpen])

    return (
        <>
            <button
                className='floatingBtn'
                type='button'
                onClick={() => setIsOpen(true)}
                aria-label='Abrir formulario de contacto'
            >
                CONTACTO
            </button>

            {isOpen && (
                <div className='floatingBackdrop' onClick={() => setIsOpen(false)}>
                    <div className='floatingModal' onClick={(e) => e.stopPropagation()}>
                        <div className='floatingModalHeader'>
                            <div>
                                <p className='floatingEyebrow'>CONTACTO</p>
                                <h3>Escribenos</h3>
                            </div>
                            <button className='floatingCloseBtn' type='button' onClick={() => setIsOpen(false)}>
                                Cerrar
                            </button>
                        </div>

                        <div className='floatingModalBody'>
                            <div className='floatingInfoCol'>
                                <h4>Informacion de contacto</h4>
                                <ul className='floatingInfoList'>
                                    <li>
                                        <Icon icon='ph:phone' />
                                        <span>{contactInfo.tel}</span>
                                    </li>
                                    <li>
                                        <Icon icon='ph:envelope' />
                                        <a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a>
                                    </li>
                                    <li>
                                        <Icon icon='ph:globe' />
                                        <span>{contactInfo.site}</span>
                                    </li>
                                    <li>
                                        <Icon icon='ph:map-pin' />
                                        <span>{contactInfo.dir}</span>
                                    </li>
                                </ul>
                                <div className='floatingInfoSocials'>
                                    <a href={socials.facebook} aria-label='Facebook'>
                                        <Icon icon='uiw:facebook' />
                                    </a>
                                    <a href={socials.twiter} aria-label='Twitter'>
                                        <Icon icon='prime:twitter' />
                                    </a>
                                    <a href={socials.telegram} aria-label='Telegram'>
                                        <Icon icon='ph:telegram-logo' />
                                    </a>
                                </div>
                            </div>

                            <div className='floatingDivider' />

                            <div className='floatingFormCol'>
                                <h4>Enviar mensaje</h4>
                                <form className='floatingForm'>
                                    <div className='floatingField'>
                                        <label htmlFor='fl-name'>Nombre</label>
                                        <input id='fl-name' type='text' placeholder='Tu nombre' />
                                    </div>
                                    <div className='floatingField'>
                                        <label htmlFor='fl-email'>Email</label>
                                        <input id='fl-email' type='email' placeholder='tu@email.com' />
                                    </div>
                                    <div className='floatingField floatingFieldGrow'>
                                        <label htmlFor='fl-msg'>Mensaje</label>
                                        <textarea id='fl-msg' placeholder='Cuentanos sobre tu proyecto' />
                                    </div>
                                    <button type='button' className='floatingSubmit'>Enviar</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default FloatingContact
